import style from "./style.scss";
import { mergeClasses } from "../helpers";
import { useState } from "preact/hooks";
import { usePopup } from "../popup/context";
import PopupImage from "../popup/image";

const ImageDetailGrid = ({
  images,
  size = 4,
  maxShow = null,
  referrerpolicy = null,
  loading = "lazy",
  border = false,
  shadow = false,
  showAlt = false,
  backgroundColor = null,
}) => {
  const [showAll, setShowAll] = useState(
    !(maxShow != null && maxShow > 0 && maxShow < images.length)
  );

  const popup = usePopup();

  const openSlideshow = (e, index) => {
    e.preventDefault();

    popup.showPopup(
      <PopupImage
        images={images}
        index={index}
        showAlt={showAlt}
        backgroundColor={backgroundColor}
        referrerpolicy={referrerpolicy}
        loading={loading}
        closePopupHandler={popup.hidePopup}
        ariaLabel={images.length > 1 ? "Image Gallery" : "Image Popup"}
      />
    );
  };

  return (
    <div class={mergeClasses([style.imageSet, style[`size-${size}`]])}>
      <ul class={style.wrapper}>
        {images
          .slice(0, showAll ? images.length : maxShow)
          .map((image, index) => (
            <li
              key={index}
              class={mergeClasses([
                style.item,
                (border == true && image.border != false) ||
                image.border == true
                  ? style.border
                  : null,
                shadow == true ? style.shadow : null,
                !showAll && index == maxShow - 1 ? style.showMore : null,
              ])}
            >
              {image.before && <div class={style.before}>{image.before}</div>}
              <div class={style.image}>
                <img
                  src={image.sm ? image.sm : image.lg}
                  alt={image.alt}
                  referrerpolicy={referrerpolicy}
                  loading={loading === "eager" ? "eager" : "lazy"}
                  onClick={(e) =>
                    !showAll && index === maxShow - 1
                      ? setShowAll(true)
                      : openSlideshow(e, index)
                  }
                />
              </div>
              {image.after && <div class={style.after}>{image.after}</div>}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ImageDetailGrid;
